import { type CommunityList, type Pagination, type PaginationData, createCommunityList } from 'models';
import { useInfiniteQuery } from 'query';
import { getCommunities } from '../services';
import type { CommunitiesListFilter } from '../types';
import { getCommunitiesInfiniteQueryKey } from './keys';

type P = {
  filter?: CommunitiesListFilter;
  pagination: Omit<Pagination, 'position'>;
};

export const useCommunitiesInfiniteQuery = ({ filter, pagination }: P) =>
  useInfiniteQuery<PaginationData<CommunityList>, string | undefined>({
    async queryFn({ pageParam: cursor }) {
      const response = await getCommunities({
        config: {
          params: {
            cursor,
            featured: filter?.featured,
            limit: pagination.pageSize,
            organization_id: filter?.organizationId,
            privacy: filter?.privacy,
            scope: filter?.scope,
            search: filter?.search,
            user_id: filter?.userId,
            view: 'table',
          },
        },
      });

      return {
        data: response.data.data.map((community) => createCommunityList(community)),
        total: response.data.total,
      };
    },
    initialPageParam: undefined,
    getNextPageParam(lastPage, allPages) {
      if (allPages.length * pagination.pageSize >= lastPage.total) {
        return undefined;
      }

      return lastPage.data.at(-1)?.id;
    },
    queryKey: getCommunitiesInfiniteQueryKey({ filter, pagination }),
  });
